import { Expose } from 'class-transformer'

export class PromotionSubCorrectionDetail<T> {
  @Expose() old: T

  @Expose() new: T
}
